const userFieldValidation = [
  'ConfirmPassword',
  'Password',
  'Username',
  'Email',
  'Roles',
];

export default userFieldValidation;
